import { api } from "..";
import { QueryProps } from "@/types/Api";
import { UserTablePreferences } from "@/types/ApiResponses/UserTablePreferences";

interface Params {
  tableKey: string;
}

export const getTablePreferences = async (
  props: QueryProps<Params>
): Promise<UserTablePreferences> => {
  const res = await api.client.get(
    `/table-preferences/${props.params.tableKey}`,
    { signal: props.signal }
  );
  return res.data;
};
